import {Component, OnInit, OnDestroy, ChangeDetectorRef} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ArrayOfKeys} from '../../../model/ArrayOfKeys';
import {UtilityService} from '../../../services/utility-service';
import {ApiService} from '../../../services/api.service';
import {LoanEntityList} from '../../../model/loanEntityList';
import {ErrorService} from '../../../shared/error-page/service/error-service';
import {Title} from '@angular/platform-browser';
import {Subscription} from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-search-update-result',
  templateUrl: './search-update-result.component.html',
  styleUrls: ['./search-update-result.component.scss']
})
export class SearchUpdateResultComponent implements OnInit, OnDestroy {

  private errorSub: Subscription;
  responseLoanEntity: LoanEntityList;
  cols: any[];
  containsError = false;
  errorMsg: string;
  pageView: any[];
  selectedPageView: string[];
  exportFilename = 'LoanListing';
  showResult: any[];
  title = 'List of Loans';

  constructor(private activeRouter: ActivatedRoute, private router: Router,
              private service: ApiService, private utilService: UtilityService, private errorService: ErrorService,
              private titleService: Title, private cdr: ChangeDetectorRef) {
    /**  Call routing Query params */
    this.fetchRecords();
    this.pageView = [];
    this.pageView.push({label: 'Printable View', value: 'printView'});
    this.pageView.push({label: 'Download To Excel', value: 'downloadtoExcel'});
    this.selectedPageView = ['printView'];

  }

  /** Define the column header */
  ngOnInit() {
    this.titleService.setTitle(this.title);
    sessionStorage.setItem('currentSubMenuOption', 'RMAcquisitions');
    this.cols = [
      {field: 'sellerNo', header: 'Seller Number'},
      {field: 'srvrno', header: 'Servicer Number'},
      {field: 'fanniemaeLnNumber', header: 'Fanniemae Loan Number'},
      {field: 'lndrLnNo', header: 'Lender Loan ID'},
      {field: 'ctrtNo', header: 'Contract Number'},
      {field: 'lnStatCd', header: 'Loan Status'},
      {field: 'prdctTypCd', header: 'Product Type'},
      {field: 'receiptDateConverted', header: 'Loan Receipt Date'},
      {field: 'docRcvdDateConverted', header: 'Doc Rcvd Date'},
      {field: 'purchaseDateConverted', header: 'Purchase Date'},
      {field: 'creatorID', header: 'User ID'}
    ];
  }

  public pageViewAction(event: any) {
    if (this.selectedPageView.toString() === 'downloadtoExcel') {
      event.exportCSV();
    }
    if (this.selectedPageView.toString() === 'printView')
    {
      const printDetailsMap = new Map();
      printDetailsMap.set('title', 'Loan List');
      printDetailsMap.set('columns', event.columns);
      printDetailsMap.set('data', this.showResult);

      this.utilService.printViewData(printDetailsMap);
      this.router.navigate(['print']);
    }
  }

  /** Onclick - navigate to Loan Detail page by loadID */
  public showLoanDetails(data: any) {
    this.loanDetails(data.loanIDValues.LoanID);
  }

  /**  Fetch records based on the routing Query params from Server */
  fetchRecords(): void {

    let arrayOfkeys: ArrayOfKeys;
    let data;

    this.activeRouter.queryParams.subscribe(params => {
      data = JSON.parse(atob(params.query));
    });

    arrayOfkeys = new ArrayOfKeys();
    arrayOfkeys.keys = data;

    /** Request  detailed loan information **/
    this.service.requestLoanDetails(arrayOfkeys).subscribe(
      (data: LoanEntityList) => {
        this.responseLoanEntity = data;
        /** Called updateUIValue method to update key to Label values */
        this.responseLoanEntity = this.convertValueToLabelAndDate(this.responseLoanEntity);
        this.showResult =  this.responseLoanEntity.listLoanEntityValue;
        this.cdr.detectChanges();
      },
      error => {
        this.errorService.announceError(error);
      }
    );
    this.errorAnnouncement();

  }

  errorAnnouncement() {
    // error announcement
    this.errorSub = this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        this.errorMsg = message;
        this.containsError = true;
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    if (this.errorSub) {
      this.errorSub.unsubscribe();
    }
  }

  /** convertValueToLabelAndDate method implemented to update key to Label values */
  convertValueToLabelAndDate(entity: LoanEntityList): any {

    entity.listLoanEntityValue.forEach(function(part, index, array) {

      const utilityService = new UtilityService();

      /** Update response date object from millisecond to Date format (MM/DD/YYYY **/
      if (array[index].receiptDate != null && array[index].receiptDate.date != null) {
        array[index].receiptDateConverted = utilityService.convertMillisecToDate(array[index].receiptDate.date);
      }
      if (array[index].docRcvdDate != null && array[index].docRcvdDate.date != null) {
        array[index].docRcvdDateConverted = utilityService.convertMillisecToDate(array[index].docRcvdDate.date);
      }
      if (array[index].purchaseDate != null && array[index].purchaseDate.date != null) {
        array[index].purchaseDateConverted = utilityService.convertMillisecToDate(array[index].purchaseDate.date);
      }

      /** Get the label value from utilService */
      utilityService.loanStatus.forEach(function(part1, index1, array1) {

        if (array1[index1].value === String(array[index].lnStatCd)) {
          array[index].lnStatCd = array1[index1].label;
        }

      });

      /** Get the label value from utilService */
      utilityService.productCode.forEach(function(part1, index1, array1) {

        if (array1[index1].value === String(array[index].prdctTypCd)) {
          array[index].prdctTypCd = array1[index1].label;
        }

      });


    });
    return entity;
  }

  /** Navigate to Loan detailed page */
  public loanDetails(inputLoanNumber: any) {
    this.router.navigate(['loanDetails'], {
      queryParams: {loanNumber: inputLoanNumber}
    });
  }
}
